import { useMutation } from "@apollo/client/react";import React, { useState } from "react";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from "../../../components/formGroupGenerator/RenderInputRowByType";
import { CREATE_COMENTARIO } from "../../../data/graphQL/mutations/GestionAsistencial/createComentarioLogistica";

import toast from "react-hot-toast";

export function AddCommentDialog({ idPaciente, idDelegacion, open, handleCloseDialog }) {
  const [fieldValue, setFieldValue] = useState("");

  const handleChange = (name, value) => {
    setFieldValue(value);
  };

  const input = {
    displayName: "Comentario",
    name: "comentario",
    type: "long_string"
  };

  const [createComentarioLogistica, { loading }] = useMutation(CREATE_COMENTARIO, {
    onCompleted: () => {
      toast.success("Comentario creado correctamente");
      handleCloseDialog();
    }
  });

  const onAccept = () => {
    createComentarioLogistica({
      variables: {
        idDelegacion: idDelegacion,
        idPaciente: idPaciente,
        comentario: fieldValue
      }
    });
  };

  return (
    <CustomDialog
      title="Nuevo comentario"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
      acceptText="Guardar"
      onAccept={onAccept}
      acceptLoading={loading}
      acceptDisabled={fieldValue.trim().length === 0}>
      
      <RenderInputsRowByType
        input={input}
        value={fieldValue}
        handleChange={handleChange} />
      
    </CustomDialog>);

}